namespace('compass.demographic');

compass.demographic.AddressWidget = compass.defineWidget(function AddressWidget(options) {
	var me = this;
	var $j = jQuery;

	var _settings = options;
	var _countryList = _.map(_settings.countries_with_states, function (c) { return c.toUpperCase(); });
	var _countryWithPostalCodes = _.map(_settings.countries_with_required_postal_codes, function (c) { return c.toUpperCase(); });

	var _validator = options.validator;

	var _labels = {
		address1: {
			label: 'Address Line 1',
			hint: 'A valid address is required'
		},
		address2: {
			label: 'Address Line 2',
			hint: 'A valid address is required'
		},
		city: {
			label: 'City',
			hint: 'A valid city is required'
		},
		postal: {
			label: 'ZIP/Postal Code',
			hint: 'A valid postal code is required for the country you have selected'
		},
		state: {
			label: 'State',
			hint: 'A state is required'
		},
		country: {
			label: 'Country',
			hint: ''
		}
	};

	if (!_settings.skipFunc) {
		_settings.skipFunc = function () { return _validator.VALID; };
	}

	var _grabValues = this.grabValues = function() {
		var values = me.find(':input,:selected').serializeArray();
		var jsonValues = {};
		jQuery.each(values, function(i, field) {
			jsonValues[field.name] = field.value;
		});

		jsonValues.address = _addressWidgetJSObject.getAddress();

		return jsonValues;
	};

	var _triggerAddressChanged = function() {
		me.trigger('addressChanged', this);
	};

	this.getAddress = function() {
		var elems = me.find(':input,:selected');
		var stuff = elems.serializeArray();
		var obj = {};
		// lets just grab the country element by hand since it could be disabled.
		var countrySelect = me.find(':input[name=country]');
		var stateSelect = me.find(':input[name=state]');
		jQuery.each(stuff, function(i, field) {
			obj[field.name] = field.value;

		});
		return {
			address1 : obj.address1,
			address2 : obj.address2,
			city : obj.city,
			state : stateSelect.val() || '',
			country : countrySelect.val(),
			postalCode : obj.postalCode
		};
	};

	this.setAddress = function(address) {
		var fields = me.find(':input');
		jQuery.each(fields, function(i, field) {
			switch (field.name) {
				case 'address1':
					jQuery(field).val(address.address1);
					break;

				case 'address2':
					jQuery(field).val(address.address2);
					break;

				case 'city':
					jQuery(field).val(address.city);
					break;

				case 'postalCode':
					jQuery(field).val(address.postalCode);
					break;

				case 'state':
					jQuery(field).val(address.state);
					break;

				case 'country':
					jQuery(field).val(address.country.toUpperCase());
					// because simply changing the value via jQuery doesn't fire events
					// we remove/add requirements according to what was selected
					updateStateRequirement();
					updatePostalRequirement();
					break;

			}
		});
	};

	this.clearAddress = function() {
		this.setAddress({
			address1 : '',
			address2 : '',
			city : '',
			postalCode : '',
			country : '',
			state : ''
		});
	};

	this.disableAddress = function() {
		me.find(':input').attr("disabled", "disabled");
	};

	this.enableAddress = function() {
		me.find(':input').attr("disabled", "");
	};

	this.grabValues = function() {
		var stuff = me.find(':input').add(':selected').serializeArray();
		jQuery.each(stuff, function(i, field) {
			alert(field.name + ':' + field.value);
		});
		return stuff;
	};

	this.render = function(widgetElem) {
		var d = _d;
		var ctry = me.drawCountry();
		var zip = me.drawPostalCode();

		widgetElem.append(
			ctry,
			me.drawAddress1(),
			me.drawAddress2(),
			me.drawCity(),
			me.drawState(),
			zip
			
		);

		//_setupControls();
	};

	this.drawAddress1 = function() {
		var d = _d;
		var field = d.fieldLabelPair({
			className : 'address1',
			label : _labels.address1.label
		}, [d.input({
			type : 'text',
			name : "address1",
			className : "address1 address1Input",
			'tabindex': '0',
			id: compass.generateId(),
			'data-parsley-required': 'true',
			'data-parsley-error-message': _labels.address1.hint,
			'data-parsley-pattern': /[^\d\s\.]/,  //Contains at least 1 alpha
			autocomplete: 'off'
		}).data("hint", _labels.address1.hint)]);
		if (_validator) {
			_validator.addFields(field.find('input'), [_settings.skipFunc, _validator.FILLED], { label: field.find('label') });
		}
		return field;
	};

	this.drawAddress2 = function() {
		var d = _d;
		var field = d.fieldLabelPair({
			className : 'address2',
			label : _labels.address2.label
		}, [d.input({
			type : 'text',
			name : "address2",
			className : "address2 address2Input",
			'tabindex': '0',
			id: compass.generateId(),
			'data-parsley-required': 'false',
			'data-parsley-error-message': _labels.address2.hint,
			'data-parsley-pattern': /[^\d\s\.]/,  //Contains at least 1 alpha
			autocomplete: 'off'
		}).data("hint", _labels.address2.hint)]);
		return field;
	};

	this.drawCity = function() {
		var d = _d;
		var field = d.fieldLabelPair({
			className : 'city',
			label : _labels.city.label
		}, [d.input({
			type : 'text',
			name : "city",
			className : "city cityInput",
			id: compass.generateId(),
			'tabindex': '0',
			'data-parsley-required': 'true',
			'data-parsley-error-message': _labels.city.hint,
			'data-parsley-pattern': /[^\d\s\.]/,  //Contains at least 1 alpha
			autocomplete: 'off'
		}).data("hint", _labels.city.hint)]);
		if (_validator) {
			_validator.addFields(field.find('input'), [_settings.skipFunc, _validator.FILLED], { label: field.find('label') });
		}
		return field;
	};

	this.drawPostalCode = function() {
		var d = _d;
		var input = d.input({
			type : 'text',
			className : 'postalCodeInput postalCode',
			name : "postalCode",
			'tabindex': '0',
			'data-parsley-required': 'true',
			'data-parsley-type': 'digits',
			'data-parsley-regexp':'^[a-zA-Z0-9 ]*$', //alphanumeric with spaces
			'data-parsley-error-message': _labels.postal.hint,
			id: compass.generateId(),
			autocomplete: 'off'
		}).data("hint", _labels.postal.hint);

		_countryField.on('change.zip', function (evt) {
			updatePostalRequirement();
		});

		var field = d.fieldLabelPair({
			className : 'postalCode',
			label : _labels.postal.label
		}, [input]);
		if (_validator) {
			_validator.addFields(field.find('input'), [_settings.skipFunc, function() {
				var hasPostalCode = _.include(_.map(_settings.countries_with_states, function(c) {
					return c.toUpperCase();
				}), _countryField.val().toUpperCase());

				if(hasPostalCode) {
					return field.find('input').val() === '' ? _validator.INVALID : _validator.VALID;
				} else {
					return _validator.IGNORED;
				}
			}], {});
		}
		return field;
	};

	var updateStateRequirement = function(){
		var select = me.find('.stateSelect');
		var state_field_pair = select.parents().find('.state.fieldPair');
		if (_.contains(_countryList, _countryField.val().toUpperCase())) {
			select.attr('data-parsley-required', 'true');
			state_field_pair.show();
		} else {
			select.removeAttr('data-parsley-required');
			state_field_pair.hide();
		}
	};

	var updatePostalRequirement = function(){
		var input = me.find('.postalCodeInput');
		if (_countryField.val().toUpperCase() === "UNITED STATES") {
			input.attr('data-parsley-required', 'true');
			input.attr('data-parsley-type', 'digits');
		} else if (_.contains(_countryList, _countryField.val().toUpperCase()) ||
							 _.contains(_countryWithPostalCodes, _countryField.val().toUpperCase())) {
			input.removeAttr('data-parsley-type');
			input.attr('data-parsley-required', 'true');
		} else {
			input.removeAttr('data-parsley-required');
			input.removeAttr('data-parsley-type');
		}
	};

	this.drawState = function() {

		var d = _d;
		var select = d.select({
			name : "state",
			className : "state stateSelect notranslate",
			id: compass.generateId(),
			'tabindex': '0',
			'data-parsley-required': 'true',
			'data-parsley-regexp':'^[a-zA-Z]*$', //alphanumeric. DO NOT remove this constraint, bug 16355
			'data-parsley-error-message': _labels.state.hint
		}, d.option({
				value : ""
			}, ""),
			$j.map(_settings.states.sort(function (a, b) { return (a.abbrv > b.abbrv) ? 1 : -1; }), function(data, i) {
			return d.option({
				value : data.abbrv
			}, data.abbrv);
		})).data("hint", _labels.state.hint);

		// when the country changes, look at the value chosen. If it requires a state require a state
		// if it doesn't require a state, remove the constraint
		// (change.state event just means that the country dropdown value changed, not the state dropdown
		// it's just a namespace to say 'we are dealing with states here')
		_countryField.on('change.state', function (evt) {
			updateStateRequirement();
			
		});

		var field = d.fieldLabelPair({
			className : 'state',
			label : _labels.state.label
		}, [select]);
		if (_validator) {
			_validator.addFields(field.find('select'), [_settings.skipFunc, function() {
				var hasStates = _.include(_.map(_settings.countries_with_states, function(c) {
					return c.toUpperCase();
				}), _countryField.val().toUpperCase());
				if(hasStates) {
					return field.find('select').val() === '' ? _validator.INVALID : _validator.VALID;
				} else {
					return _validator.IGNORED;
				}
			}], {});
		}
		return field;
	};

	var _countryField;
	this.drawCountry = function() {
		var d = _d;
		var field = d.fieldLabelPair({
			className : 'country',
			label : _labels.country.label
		}, [d.select({
			name : "country",
			'tabindex': '0',
			id: compass.generateId(),
			className : "country"
		}, $j.map(_settings.countries, function(data, i) {
			return d.option({
				selected : data.name.toUpperCase() === 'UNITED STATES',
				value : data.name.toUpperCase()
			}, data.name);
		}))]);
		_countryField = field.find('select');
		return field;
	};

	var _d = jQuery.dom.getContext(this);

}, {
	WUID : 'CRAP',
	widgetName : 'AddressWidget',
	countries : [{name:"UNITED STATES"},{name :"CANADA"}, {name:"UNITED KINGDOM"}, {name:"POLAND"}],
	states : [{"abbrv": "AL", "name": "Alabama"}, {"abbrv": "AK", "name": "Alaska"}, {"abbrv": "AZ", "name": "Arizona"}],
	countries_with_states : ["UNITED STATES","CANADA"],
	countries_with_required_postal_codes: []
});

